export const updateWaiverFilter = (filterString) => (dispatch) => {
  dispatch({
    type: 'UPDATE_ADMIN_WAIVERS_PAGE_FILTER_STRING',
    payload: filterString
  });
};

export const updateSelectedWaiver = (Waiver) => (dispatch) => {
  dispatch({ type: 'UPDATE_ADMIN_WAIVERS_PAGE_SELECTED_WAIVER', payload: Waiver });
};
